<script lang="ts">
    import InputField from "../../materialize/forms/InputField.svelte";
    import Select from "../../materialize/forms/Select.svelte";
    import TextField from "../../materialize/forms/TextField.svelte";
    import Column from "../../materialize/grid/Column.svelte";
    import Row from "../../materialize/grid/Row.svelte";
    import { push, pop, replace } from "svelte-spa-router";
    import { current_dialect, current_expanded_result_id, languages } from "../../stores/stores";
    import { onMount } from "svelte";
    let chosen_dialect: number;
    let chosen_word: string;
    let textfield_for_word;

    export const focus_search_text = ()=>{textfield_for_word.focus();};

    onMount(
        ()=>{
            //focus_search_text();
        }
    )
</script>

<form autocomplete="off"
    on:submit|preventDefault
    on:submit|preventDefault={() => {
        $current_expanded_result_id = -1;
        $current_dialect = $languages.find( (l)=> l.id == chosen_dialect );
        chosen_word = chosen_word.trim();
        push(`/search/${chosen_dialect}/${encodeURIComponent(chosen_word)}`);
    }}
>
    <Row>
        <Column small={8}>
            <InputField>
                <TextField
                    bind:this={textfield_for_word}
                    bind:value={chosen_word}
                    required="true"
                    label_text="Parola da cercare"
                    id="field_parola_cerca"
                />
            </InputField>
        </Column>
        <Column small={4}>
            <button type="submit" class="waves-effect waves-light btn btn-large"
                ><i class="material-icons">search</i></button
            >
        </Column>
        {#if $languages.length}
            <Column small={12} large={6}>
                <InputField
                    helper_text="Seleziona il dialetto preferito per la ricerca"
                    helper_text_success="Già selezionato"
                    helper_text_wrong="Scegli un dialetto dall'elenco"
                >
                    <Select
                        options={$languages.filter((e)=>e.iso_code!=="it").map((e)=>e.format_for_selectform())}
                        bind:value={chosen_dialect}
                        required="true"
                        label="Dialetto preferito"
                    />
                </InputField>
            </Column>
        {/if}
    </Row>
</form>
